module.exports = __webpack_public_path__ + "static/img/ri.5d7340d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/ri.jpg
// module id = eaHk
// module chunks = 0